import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import VScroll_Item from '../_app/cuchillo/scroll/VScroll_Item';
import { GetBy } from '../_app/cuchillo/core/Element';
import { SplitText } from 'gsap/SplitText';
import { gsap, Power3, Quad } from 'gsap';
import { Functions } from '../_app/cuchillo/utils/Functions';
gsap.registerPlugin(SplitText);

export default class ScrollItem__Default extends VScroll_Item {
  titleTimeline;
  strokeTimeline;
  hasHiddenEnabled = false;
  hasEffect = true;

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);


    if(this.item.dataset.effect == "false") {
      this.hasEffect = false;
    }

    if(this.hasEffect) {
      //this.setupStrokeText();

      this.onShow = () => {
       // this.showDefault();
      };
    }
  }

  setupStrokeText() {
    const titles = [...GetBy.selector("h1", this.item), ...GetBy.selector("h2", this.item)];
    this.titleTimeline = this.TimelineSplitTextIntro(titles,"title",null,null,0);
    const p = [...GetBy.selector("p", this.item)];
    this.strokeTimeline = this.TimelineSplitTextIntro(p,"p",null,null,0);
  }

  showDefault() {
    this.titleTimeline.play();
    this.strokeTimeline.play();
  }

  TimelineSplitTextIntro(__items, __id, __call, __tl, __delay = 0) {
    const _class = __id + "__" + new Date().getTime();
    let tl = __tl ? __tl : new gsap.timeline();

    for (let i = 0; i < __items.length; i++) {
      __items[i].classList.add(_class);
    }

    tl.pause();

    const split = new SplitText("." + _class, { type: "words", wordsClass: "_c_" + _class });
    let items = split.words;//Functions.arrayRandom(split.words);

    let direction = -1;
    for (let i = 0; i < items.length; i++) {
      direction *= -1;
      let isLast = i == items.length - 1;

      tl.from(items[i], {
        alpha: 0, duration: 0.1, ease: Power3.easeOut, force3D: true, onComplete: () => {
          if (isLast && __call) __call();
        }
      }, __delay);

      tl.from(items[i], { color: "#F4FF64", duration: .2 + (.1 * i), ease: Quad.easeOut, force3D: true }, __delay + .01);
      __delay += .025;
    }

    return tl;
  }

  dispose() {
    if (this.titleTimeline) {
      this.titleTimeline.kill();
      this.titleTimeline = null;
    }
    if (this.strokeTimeline) {
      this.strokeTimeline.kill();
      this.strokeTimeline = null;
    }

    super.dispose();
  }
}


Scroll._registerClass('default', ScrollItem__Default);
